import React from 'react';
import { makeStyles } from 'tss-react/mui';
import PinnedIndicator from './PinnedIndicator';
import VideoMenuTriggerButton from './VideoMenuTriggerButton';
import { getIndicatorsTooltipPosition } from '../../functions.web';
const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            justifyContent: 'center',
            columnGap: '20px',
            borderRadius: '20px',
            '&:has(div[class$="pinnedIndicator"])': {
                backgroundColor: theme.palette.black + '50',
                padding: '4px 12px',
            },
            '& > *:not(:last-child)': {
            // marginRight: '4px'
            }
        }
    };
});
const ThumbnailCenterIndicators = ({ disableConnectionIndicator, hidePopover, indicatorsClassName, isHovered, local, participantId, popoverVisible, showPopover, thumbnailType }) => {
    const { classes: styles } = useStyles();
    const { NORMAL = 16 } = interfaceConfig.INDICATOR_FONT_SIZES || {};
    const _indicatorIconSize = 20;
    const tooltipPosition = getIndicatorsTooltipPosition();
    return (React.createElement("div", { className: styles.container },
        isHovered && React.createElement(PinnedIndicator, { iconSize: _indicatorIconSize, participantId: participantId, tooltipPosition: tooltipPosition, pinAll: true }),
        isHovered && React.createElement(PinnedIndicator, { iconSize: _indicatorIconSize, participantId: participantId, tooltipPosition: tooltipPosition, pinAll: false }),
        React.createElement(VideoMenuTriggerButton, { hidePopover: hidePopover, local: local, participantId: participantId, popoverVisible: popoverVisible, showPopover: showPopover, thumbnailType: thumbnailType, visible: isHovered })));
};
export default ThumbnailCenterIndicators;
